<template>
  <div class="car-count">
    <table
      class="cart-goods-list"
      v-for="(item, shopIndex) in carList"
      :key="item.shopId"
    >
      <caption>
        {{
          item.title
        }}
      </caption>
      <colgroup>
        <col span="1" width="40px" />
        <col span="1" width="110px" />
        <col span="1" width="370px" />
        <col span="1" width="130px" />
        <col span="1" width="180px" />
        <col span="1" width="130px" />
        <col span="1" width="140px" />
      </colgroup>
      <thead>
        <tr>
          <th>
            <!-- <div class="btns centerboth" v-if="item.selected==true" @click="selShop(shopIndex)">
						<text class="iconfont car-sel"></text>
					</div>
					<div class="btns centerboth" v-else @click="selShop(shopIndex)">
						<text class="iconfont car-unsel"></text>
					</div> -->
          </th>
          <th colspan="2">商品</th>
          <th>单价</th>
          <th>数量</th>
          <th>小计</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(itm, gIndex) in item.glist" :key="itm.goods_id">
          <td>
            <!-- <div class="btns centerboth" v-if="itm.selected==true" @click="selThis(shopIndex,gIndex)">
					<text class="iconfont car-sel"></text>
				</div>
				<div class="btns centerboth" v-else @click="selThis(shopIndex,gIndex)">
					<text class="iconfont car-unsel"></text>
				</div> -->
          </td>
          <td>
            <img class="goods-image" :src="itm.image" mode="aspectFill" />
          </td>
          <td>
            <h3>{{ itm.goods_name }}</h3>
            <p>
              <span>{{ itm.spec_key_name }}</span>
            </p>
          </td>
          <td>
            ￥<span class="yj-price">{{ itm.price }}</span>
          </td>
          <td>
            <div class="counter">
              <span
                class="left"
                @click="
                  changeNum(
                    item.total,
                    shopIndex,
                    gIndex,
                    itm.stock,
                    itm.buy_num,
                    0,
                    itm._id,
                    itm.goods_id,
                  )
                "
                ><img src="../../assets/images/icon-decrease.png"
              /></span>
              <div class="center">{{ itm.buy_num }}</div>
              <span
                class="right"
                @click="
                  changeNum(
                    item.total,
                    shopIndex,
                    gIndex,
                    itm.stock,
                    itm.buy_num,
                    1,
                    itm._id,
                    itm.goods_id,
                  )
                "
                ><img src="../../assets/images/icon-increase.png"
              /></span>
            </div>
          </td>
          <td>
            ￥<span class="yj-price">{{ itm.price }}</span>
          </td>
          <td>
            <span
              class="delete"
              @click="deleteGoodsItem(shopIndex, gIndex, itm._id, itm.goods_id)"
              >删除</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div class="car-bottom-btn">
      <!-- <div class="all-sel-btn centerboth" @click="allSelBtn">
				<text v-if="allSel==true" class="iconfont car-sel"></text>
				<text v-else class="iconfont car-unsel"></text>
				全选
			</div> -->
      <div class="all-cost centerboth">
        <!-- 合计:<text class="icon">￥</text><text class="money">{{allAmount}}</text> -->
        合计：<span class="icon">￥</span
        ><span class="money">{{ totalPrice }}</span>
      </div>
      <div class="car-btn-box centerboth">
        <!-- <div class="del-btn centerboth" @click="delCars">删除</div> -->
        <div class="js-btn centerboth" @click="jsCars">
          <!-- 结算({{allNumber}}) -->
          去结算({{ totalNum }})
        </div>
      </div>
    </div>
    <mask-model
      ref="askmodel"
      btnType="1"
      @confirm="confirm"
      @cancel="cancel"
      titleColoe="#666666"
      cancelColor="#666666"
      confirmColor="#007AFF"
      :maskTitle="maskTitle"
    ></mask-model>
  </div>
</template>
<script>
import maskModel from '@/components/mask-model/mask-model.vue';
export default {
  components: {
    maskModel,
  },
  props: {
    carList: {
      //提示信息字体颜色
      type: Array,
      default() {
        return [];
      },
    },
    totalPrice: {
      type: String,
    },
    totalNum: {
      type: Number,
    },
  },
  data() {
    return {
      maskTitle: '',
      allSel: true,
      allAmount: '0.00',
      allNumber: 0,
      delIds: '', //要删除的购物车id
      btnType: 0, //0删除  1结算
      deleteGoods: false,
    };
  },
  computed: {},
  mounted() {
    this.getAllMount();
  },
  created() {},
  methods: {
    confirm: function() {
      //确定按钮
      var that = this;
      console.log('您点击了确定按钮');
      if (that.btnType == 0) {
        that.$emit('delbtn', that.delIds, that.carList);
      } else {
        let ids = that.getCarIds();
        this.$emit('jsbtn', ids);
      }
    },
    cancel: function() {
      //取消按钮
      console.log('您点击了取消按钮');
    },
    jsCars: function() {
      var that = this;
      that.btnType = 1;
      that.$refs.askmodel.show();
      that.maskTitle = '是否结算选中的商品?';
    },
    delCars: function() {
      var that = this;
      that.delIds = ''; //清除上次删除记录
      var delIds = that.getCarIds();

      if (!delIds) {
        // uni.showToast({
        //   title: '请选择要删除的商品',
        //   icon: 'none',
        // });
        return false;
      }

      that.delIds = delIds;
      that.btnType = 0;
      that.$refs.askmodel.show();
      that.maskTitle = '是否将选中商品移除购物车?';
    },
    selThis: function(shopIndex, gIndex) {
      //选择商品
      var that = this;
      let carList = that.carList;
      if (carList[shopIndex].glist[gIndex].selected == false) {
        carList[shopIndex].glist[gIndex].selected = true;
      } else {
        carList[shopIndex].glist[gIndex].selected = false;
      }
      for (let i = 0; i < carList.length; i++) {
        var indexNum = 0;
        for (let k = 0; k < carList[i].glist.length; k++) {
          if (carList[i].glist[k].selected == false) {
            carList[i].selected = false;
          } else {
            indexNum = indexNum + 1;
            if (indexNum > 0 && carList[i].glist.length == indexNum) {
              carList[i].selected = true;
            }
          }
        }
      }

      that.setAllSel();
      that.$emit('selGoods', carList);
    },
    selShop: function(shopIndex) {
      var that = this;
      let carList = that.carList;
      if (carList[shopIndex].selected == false) {
        carList[shopIndex].selected = true;
        for (let i = 0; i < carList[shopIndex].glist.length; i++) {
          carList[shopIndex].glist[i].selected = true;
        }
      } else {
        carList[shopIndex].selected = false;
        for (let i = 0; i < carList[shopIndex].glist.length; i++) {
          carList[shopIndex].glist[i].selected = false;
        }
      }
      that.setAllSel();
      that.$emit('selShop', carList);
    },
    setAllSel: function() {
      //是否全选
      let shopNum = 0;
      for (let i = 0; i < this.carList.length; i++) {
        if (this.carList[i].selected == true) {
          shopNum = shopNum + 1;
        }
      }
      if (shopNum == this.carList.length && shopNum > 0) {
        this.allSel = true;
      } else {
        this.allSel = false;
      }
      this.getAllMount();
    },
    allSelBtn: function() {
      //全选
      var that = this;
      this.allSel = !this.allSel;
      var carList = that.carList;
      for (let i = 0; i < carList.length; i++) {
        for (let k = 0; k < carList[i].glist.length; k++) {
          if (this.allSel) {
            carList[i].glist[k].selected = true;
            carList[i].selected = true;
          } else {
            carList[i].selected = false;
            carList[i].glist[k].selected = false;
          }
        }
      }
      that.$emit('allSelBtn', carList);
      that.getAllMount();
    },
    getAllMount: function() {
      //计算选中总价
      var that = this;
      let allPrice = 0;
      var selNum = 0;
      let carList = that.carList;
      for (let i = 0; i < carList.length; i++) {
        for (let k = 0; k < carList[i].glist.length; k++) {
          if (carList[i].glist[k].selected == true) {
            selNum = selNum + carList[i].glist[k].buy_num;
            allPrice =
              allPrice +
              carList[i].glist[k].buy_num * carList[i].glist[k].price;
          }
        }
      }
      that.allNumber = selNum;
      that.allAmount = allPrice.toFixed(2);
    },
    getCarIds: function() {
      //获取要结算的商品
      var that = this;
      var carList = that.carList;
      var haveSel = [];
      for (let i = 0; i < carList.length; i++) {
        for (let k = 0; k < carList[i].glist.length; k++) {
          if (carList[i].glist[k].selected == true) {
            let idStr = {};
            idStr =
              carList[i].glist[k]._id +
              '_' +
              carList[i].glist[k].goods_id +
              '_' +
              carList[i].glist[k].buy_num;
            haveSel.push(idStr);
          }
        }
      }
      if (haveSel.length == 0) {
        // uni.showToast({
        //   title: '请选择要结算的商品',
        //   icon: 'none',
        // });
        return false;
      }
      let cartIds = haveSel.join(',');
      return cartIds;
    },
    changeNum: function(
      total,
      shopIndex,
      gIndex,
      stock,
      buy_num,
      type,
      _id,
      goods_id,
    ) {
      //适用于根据数量改变购物车
      var that = this;
      var carList = that.carList;
      that.deleteGoods = false;
      if (type == 0) {
        //减少
        // if (buy_num < 0) {
        //   return false;
        // }
        // if (buy_num == 0) {
        //   carList.splice(shopIndex, 1); //添加为0时移除
        // }
        // console.log('数量减少了');
        // buy_num = buy_num - 1;
        if (buy_num == 1) {
          buy_num = 1;
          that.deleteGoods = true;
        } else {
          buy_num = buy_num - 1;
        }
      } else {
        //增加
        if (buy_num >= stock) {
          alert('库存不足');
          return false;
        }
        buy_num = buy_num + 1;
      }
      console.log('+++++++_____-----', buy_num);
      that.$emit(
        'changeNum',
        total,
        carList,
        shopIndex,
        gIndex,
        buy_num,
        _id,
        type,
        goods_id,
        stock,
        that.deleteGoods,
      );
    },
    deleteGoodsItem(shopIndex, gIndex, _id, goods_id) {
      let that = this;
      var carList = that.carList;
      that.$emit('deleteGoodsItem', carList, shopIndex, gIndex, _id, goods_id);
    },
  },
};
</script>

<style scoped lang="less">
.cart-goods-list {
  width: 100%;
  margin-bottom: 10px;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
  line-height: 20px;
  background: #fff;
  thead {
    tr th {
      margin: 0;
      padding: 15px 15px;
      font-weight: normal;
      line-height: 20px;
      text-align: left;
    }
  }
  tbody {
    tr td {
      margin: 0;
      padding: 15px 15px;
      border-top: 6px solid #f8f8f8;
      .goods-image {
        width: 80px;
        height: 80px;
      }
      h3 {
        margin-bottom: 6px;
        font-weight: bold;
        font-size: 14px;
      }
      .delete {
        color: #f15b49;
        cursor: pointer;
      }
    }
  }
}
.counter {
  display: flex;
  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    border: 1px solid #e0e0e0;
    background: #f8f8f8;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .left {
    border-radius: 4px 0 0 4px;
  }
  .right {
    border-radius: 0 4px 4px 0;
  }
  .center {
    width: 40px;
    border-color: #e0e0e0;
    border-style: solid;
    border-width: 1px 0 1px 0;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
  }
}
.car-count {
  width: 1100px;
  margin: 20px auto;
}
.manage-btn {
  width: 100%;
  height: 75px;
  text-align: right;
  background: #ffffff;
}
.manage-btn text {
  padding: 0 24px;
  color: #76a28c;
  font-size: 30px;
  line-height: 75px;
}
.all-sel-btn {
  float: left;
  height: 100%;
}
.all-sel-btn .iconfont {
  margin-right: 10px;
  color: #00a2ea;
}
.car-list {
  width: 100%;
}
.car-list .list {
  display: flex;
  width: 100%;
  /*padding: 20px 20px 20px 0;*/
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
  border-radius: 10px;
  background: #ffffff;
}
.car-list .list:nth-child(1) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.car-list .list:nth-last-child(1) {
  margin: 0;
}
.car-list .list .btns {
  width: 70px;
  height: 190px;
}
.car-list .list .btns .iconfont {
  color: #00a2ea;
  font-size: 38px;
}

.car-list .list .car-img {
  width: 100px;
  height: 100px;
}

.car-list .list .car-mes {
  flex: 1;
  margin-left: 20px;
}

.car-list .g-name {
  color: #2a2a2a;
  font-size: 16px;
  /* height: 38px; */
}

.car-list .mes-box {
  width: 100%;
}

.car-list .gz-box {
  margin: 10px 0;
  color: #999999;
  font-size: 26px;
}

.car-list .mes-box .price {
  font-size: 16px;
}

.car-list .mes-box .yj-price {
  font-size: 36px;
}

.car-list .price .num {
  float: right;
  color: #2a2a2a;
  font-weight: normal;
  font-size: 28px;
}

.car-list .num-box {
  float: right;
}

.car-list .num-box .iconfont {
  color: #999999;
  font-size: 18px;
}

.car-list .num-box div {
  width: 60px;
  height: 50px;
  margin: 0 10px;
  color: #2a2a2a;
  font-size: 18px;
  line-height: 50px;
  text-align: center;
}

.price-change-num .price {
  float: left;
}

.car-bottom-btn {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  padding: 0 40px 0 40px;
  z-index: 6;
  background: #ffffff;
  // box-shadow: 0px -2px 10px -2px #d0d0d0;
}
.car-bottom-btn .all-cost {
  margin-right: 10px;
}
.car-bottom-btn .all-cost .icon {
  color: #f15b49;
  font-weight: bold;
}
.car-bottom-btn .all-cost .money {
  color: #f15b49;
  font-weight: bold;
}
.car-bottom-btn text {
  color: #ff5621;
  font-size: 38px;
  line-height: 80px;
}
.car-btn-box {
  height: 100%;
  z-index: 9;
}
.car-btn-box div {
  padding: 8px 30px;
  border-radius: 18px;
  background: #31a775;
  cursor: pointer;
}
.del-btn {
  color: #ffffff;
  background: red;
}
.js-btn {
  color: #ffffff;
  background: #00a2ea;
}
.shop-mes {
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
  background: #ffffff;
}
.shop-mes .iconfont {
  margin-right: 20px;
  color: #00a2ea;
  font-size: 38px;
}
.shop-mes .name-mes {
  float: left;
}
div,
textarea,
input,
text,
button {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 16px;
  /*font-family: '微软雅黑' sans-serif;*/
}
.uni-checkbox-input {
  border-radius: 50% !important;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}
.line1 {
  display: flex;
  /*display: -webkit-box;*/
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all; /* 英文换行问题 */
  line-clamp: 1;
  /*box-orient: vertical;*/
  /*-webkit-line-clamp: 1;*/
  /*-webkit-box-orient: vertical;*/
}
.line2 {
  display: flex;
  /*display: -webkit-box;*/
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all; /* 英文换行问题 */
  line-clamp: 2;
  /*box-orient: vertical;*/
  /*-webkit-line-clamp: 2;*/
  /*-webkit-box-orient: vertical;*/
}
.centerboth {
  display: flex;
  /*display: -webkit-flex;*/
  /*-webkit-align-items: center;*/
  align-items: center;
  /*-webkit-justify-content: center;*/
  justify-content: center;
}
.clearfix:after {
  display: block;
  clear: both;
  height: 0;
  content: '';
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
image {
  margin: 0;
  padding: 0;
}
textarea {
  display: block;
  width: 300px;
  height: 75px;
  position: relative;
  font-size: 28px;
}
button::after {
  border: none;
}
</style>
